var _style, _rect, _rect2, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendarV2 = function SvgCalendarV2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgCalendar2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgCalendar2{fill:#AAABAD;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.6,
    y: 2.3,
    className: "svgCalendar2 svgBase svgHover svgSelect",
    width: 1.8,
    height: 3.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.7,
    y: 2.3,
    className: "svgCalendar2 svgBase svgHover svgSelect",
    width: 1.8,
    height: 3.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgCalendar2 svgBase svgHover svgSelect",
    d: "M20.7,5.6V3.8h-2.4V7h-3.5V3.8H8.4V7H4.8V3.8H2.4v17.1h5.2v2.8h15.9V5.6H20.7z M13.4,10.9 c0.8,0,1.4-0.5,1.6-1.2c0.1-0.1,0.2-0.2,0.3-0.3c0.4,0,0.8,0,1.2,0v7.9h-1.8v-4.5c0-0.3-0.1-0.4-0.4-0.4h-1.5c0-0.5-0.1-0.9-0.1-1.4 C13,10.9,13.1,10.9,13.4,10.9z M7.6,17.2c-1-0.4-1.6-1.4-1.6-2.5c0-0.1,0.1-0.3,0.3-0.3c0.5,0,0.9,0,1.4,0c0,0.3,0.1,0.5,0.2,0.8 c0.2,0.5,0.8,0.8,1.4,0.7c0.5-0.1,0.9-0.6,0.8-1.1c0-0.5-0.4-0.9-0.9-0.8c-0.9-0.1-0.9-0.1-0.9-1v-0.3c1.4-0.2,1.6-0.3,1.6-0.9 c0-0.5-0.4-0.8-0.9-0.8c-0.6-0.1-1,0.3-1.1,1.3H6.3C6.2,10.9,6.9,9.8,8,9.4c0.8-0.3,1.7-0.2,2.5,0.2c1,0.5,1.5,1.7,1,2.7 c-0.1,0.3-0.3,0.5-0.5,0.7c0.9,0.4,1.3,1.5,1,2.4c-0.3,1-1.1,1.8-2.2,2C9.1,17.6,8.3,17.5,7.6,17.2z M22.4,22.6L22.4,22.6L22.4,22.6 H8.8v-1.7h11.9V6.7h0.1h1.6h0.1V22.6z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarV2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar_v2.11b0cbf8.svg";
export { ForwardRef as ReactComponent };